import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton, DeleteButton, FormWhiteContainer, WhiteContainer } from '../assets/style';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import FormLabel from '../components/FormLabel';
import { useLocation, useNavigate } from 'react-router';
import { companyPageName } from '../components/PageName';
import { useLazyGetCompanyByIdQuery } from '../features/comapny/comapnySlice';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice';
import { Permissions } from '../utils/Permissions';

const CompanyDetailPage = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const getLocation = useLocation();
    var company = getLocation?.state;
    console.log("company, ", company)
    const [getCompanyQuery, companyQueryResult] = useLazyGetCompanyByIdQuery();
    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        handleCompanyData()
    }, []);

    const handleCompanyData = async () => {
        try {
            console.log("getting data, ", company?.id);
            if (localStorage.accessToken) {
                await getCompanyQuery(company?.id)
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error);
        } finally {
            // Code to execute after the try-catch block, regardless of success or failure
        }
    };

    return (
        <MainContent type={companyPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <Box sx={{ display: "row" }}>
                        <BigHeading>{t("Company Detail")}</BigHeading>
                        {
                            permissions.includes(Permissions.CompanyEdit)
                            && <ShortBlueButton onClick={() => { navigate('/add-company', { state: company }); }}>Edit</ShortBlueButton>
                        }
                    </Box>


                    <FormLabel title={t("Company Name")} value={companyQueryResult.data?.name ? companyQueryResult.data?.name : "/"} />
                    <FormLabel title={t("Is Active")} value={companyQueryResult?.data?.isActive ? "Yes" : "None"} />
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <BackButton onClick={() => { navigate('/company') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default CompanyDetailPage;